/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductMarketingOptGetResponse } from '../models/product-marketing-opt-get-response';
import { ProductMarketingOptProcessRequest } from '../models/product-marketing-opt-process-request';

@Injectable({
  providedIn: 'root',
})
export class MarketingOptService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1MarketingOptProcessPost
   */
  static readonly V1MarketingOptProcessPostPath = '/v1/marketing-opt/process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingOptProcessPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingOptProcessPost$Plain$Response(params?: {
    body?: ProductMarketingOptProcessRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingOptGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingOptService.V1MarketingOptProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingOptGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingOptProcessPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingOptProcessPost$Plain(params?: {
    body?: ProductMarketingOptProcessRequest
  },
  context?: HttpContext

): Observable<ProductMarketingOptGetResponse> {

    return this.v1MarketingOptProcessPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingOptGetResponse>) => r.body as ProductMarketingOptGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingOptProcessPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingOptProcessPost$Json$Response(params?: {
    body?: ProductMarketingOptProcessRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingOptGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingOptService.V1MarketingOptProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingOptGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingOptProcessPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingOptProcessPost$Json(params?: {
    body?: ProductMarketingOptProcessRequest
  },
  context?: HttpContext

): Observable<ProductMarketingOptGetResponse> {

    return this.v1MarketingOptProcessPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingOptGetResponse>) => r.body as ProductMarketingOptGetResponse)
    );
  }

  /**
   * Path part for operation v1MarketingOptGetGet
   */
  static readonly V1MarketingOptGetGetPath = '/v1/marketing-opt/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingOptGetGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1MarketingOptGetGet$Plain$Response(params?: {
    ProductId?: string;
    CustomerId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingOptGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingOptService.V1MarketingOptGetGetPath, 'get');
    if (params) {
      rb.query('ProductId', params.ProductId, {});
      rb.query('CustomerId', params.CustomerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingOptGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingOptGetGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1MarketingOptGetGet$Plain(params?: {
    ProductId?: string;
    CustomerId?: string;
  },
  context?: HttpContext

): Observable<ProductMarketingOptGetResponse> {

    return this.v1MarketingOptGetGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingOptGetResponse>) => r.body as ProductMarketingOptGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingOptGetGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1MarketingOptGetGet$Json$Response(params?: {
    ProductId?: string;
    CustomerId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingOptGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingOptService.V1MarketingOptGetGetPath, 'get');
    if (params) {
      rb.query('ProductId', params.ProductId, {});
      rb.query('CustomerId', params.CustomerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingOptGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingOptGetGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1MarketingOptGetGet$Json(params?: {
    ProductId?: string;
    CustomerId?: string;
  },
  context?: HttpContext

): Observable<ProductMarketingOptGetResponse> {

    return this.v1MarketingOptGetGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingOptGetResponse>) => r.body as ProductMarketingOptGetResponse)
    );
  }

}
